// Поддерживается вручную в синхроне с backend `WalletTransactionTypeIdEnum`
// (libs/types/src/balance/wallet/enums/wallet-transaction-type-id.enum.ts).
// При добавлении нового id на бэке — добавить и сюда.
export const LogType: Record<number, string> = {
  1: "deposit items",
  2: "double game bet",
  3: "shop purchase",
  4: "double game win",
  5: "referral",
  6: "classic or fast played",
  7: "shop revoke",
  8: "warwick reserve",
  9: "warwick release",
  10: "warwick winning",
  11: "payment",
  12: "duel game bet",
  13: "duel game win",
  14: "duel game return",
  15: "balance payment",
  16: "free coins",
  17: "referral welcome bonus",
  18: "slots game bet",
  19: "slots game winning",
  20: "crash game bet",
  21: "crash game win",
  22: "manual refund",
  23: "trade refund",
  24: "promocode",
  25: "king bet",
  26: "king win",
  27: "king bonus",
  28: "upgrader play",
  29: "upgrader sell",
  30: "case play",
  31: "case sell",
  32: "daily gifts",
  33: "global pot",
  34: "wheel refill",
  35: "skin sell",
  36: "x50 bet",
  37: "x50 win",
  38: "virtual bet",
  39: "payout",
  40: "payout revoke",
  41: "tower game bet",
  42: "tower game win",
  43: "wheel spin",
  44: "mini jackpot win",
  45: "double game triple win",
  46: "hilo bet",
  47: "hilo win",
  48: "jackpot reward",
  49: "boost reward",
  50: "money move from dapubg",
  51: "xp reward",
  52: "cashback reward",
  53: "baccarat play",
  54: "baccarat win",
  55: "cross return",
  56: "poggi slots bet",
  57: "poggi slots win",
  58: "wheel free bonus",
  59: "cases free bonus",
  60: "http api take",
  61: "leaders race reward",
  62: "taking raffle item",
  63: "unused money",
  64: "inventory sell",
  65: "inventory buy",
  67: "p2p payout",
  68: "p2p refund",
  69: "p2p refill",
  70: "p2p bot refill",
  71: "offerwall payment",
  72: "reset balance",
  80: "case battle bet",
  81: "case battle win",
  82: "case battle revenge accept",
  83: "case battle revenge refund",
  90: "case refund",
  91: "inventory withdraw refund",
  100: "rain bet",
  101: "rain refill",
  102: "rain reward",
  103: "raffle refill",
  104: "raffle reward",
  105: "raffle reward create",
  106: "raffle reward delete",
  500: "quest pay",
  501: "quest pay refund",
  503: "quest reward",
  504: "lucky bonus",
  505: "bonus from bet",
  506: "get bonus",
  507: "quest calendar reward",
  508: "get free wallet",
  509: "exchange wallet",
  510: "deposit items compensation hold",
  600: "solitaire entry cost",
  601: "solitaire prize",
  602: "solitaire refund",
  700: "bet stake",
  701: "bet win",
  702: "bet refund",
  703: "bet rollback",
  704: "bet discard refund",
};
